module.exports = "/build/images/logo_footer.png?710048aff68ada60bf9b69942ab2a81e";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/logo_footer.png
// module id = 2428
// module chunks = 0